module.exports = __webpack_public_path__ + "static/media/tribunal.3f91f71a.svg";